import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'lib-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
  standalone: false,
})
export class ImagePreviewComponent implements OnChanges, OnDestroy {
  @Input() fileOrBlob: Blob | File | null = null;

  imageUrl: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileOrBlob']) {
      this.updateImage();
    }
  }

  private updateImage(): void {
    // Alte URL freigeben
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = null;
    }

    if (this.fileOrBlob) {
      this.imageUrl = URL.createObjectURL(this.fileOrBlob);
    }
  }

  ngOnDestroy(): void {
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
    }
  }
}
